// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bots-overview {
  font-family: "DM Sans", sans-serif;
  max-width: var(--max-width-10xl, 120rem);
  margin: 0 auto;
  padding: 22px 24px 48px;
}

.bots-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 10px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 20px;
  line-height: 1.45;
  max-width: 800px;
}

.bots-info-box p {
  padding: 0;
  margin: 0;
}

.bots-info-icon {
  font-size: 32px;
  color: #5616ea;
}

.name-button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid rgb(231, 231, 231);
}

.name-status-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bot-status-icon {
  color: #5616ea;
  font-size: 25px;
}

.bot-status-icon-failed {
  color: rgb(214, 8, 8);
  font-size: 25px;
}

.url-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.plan-info-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.plan-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.plan-info-action-button {
  border: none;
  background-color: #5616ea;
  font-size: 13px;
  text-align: center;
  padding: 4px;
  padding-right: 6px;
  padding-left: 6px;
  border-radius: 8px;
  color: white;
  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  cursor: pointer;
  will-change: transform;
  backface-visibility: hidden;
}

.plan-info-action-button:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}

.plan-info-action-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: scale(1.0);
  background-color: rgb(78, 78, 78);
}

/* Red variant of the plan-info action button, shown when the bot's
   subscription is past_due. Clicking it opens the Stripe customer
   portal directly on the "update payment method" flow. */
.plan-info-action-button-update-payment {
  background-color: #dc2626;
}

.plan-info-action-button-update-payment:hover {
  background-color: #b91c1c;
}

.plan-info-action-button-content {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 14px;
}

.star-icon-tooltip-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: default;
  transform: translateY(1.5px);
}

.star-icon-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #5616ea;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
  box-shadow: 0 4px 12px rgba(86, 22, 234, 0.3);
}

.star-icon-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #5616ea;
}

.star-icon-tooltip-wrapper:hover .star-icon-tooltip {
  opacity: 1;
}

.star-icon-pro-subscription {
  color: #5616ea;
}

.star-icon-trialing {
  color: #3b82f6;
}

.star-icon-expires {
  color: #f59e0b;
}

.star-icon-cancelled {
  color: #ef4444;
}

.star-icon-past-due {
  color: #ef4444;
}

.messages-used-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.created-at-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.activity-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -2px;
}

/* Agent availability row (Online/Offline toggle) */
.agent-availability-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
  margin-bottom: 4px;
}

.agent-availability-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;
  min-width: 96px;
}

.agent-availability-toggle.online {
  background-color: #ede9fe;
  color: #5616ea;
}

.agent-availability-toggle.online:hover:not(:disabled) {
  background-color: #ddd6fe;
}

.agent-availability-toggle.offline {
  background-color: #fef2f2;
  color: #dc2626;
}

.agent-availability-toggle.offline:hover:not(:disabled) {
  background-color: #fee2e2;
}

.agent-availability-toggle:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  background-color: #f3f4f6;
  color: #9ca3af;
}

/* Neutral placeholder shown while initial agent_status fetch is in
   flight. Same shape/size as the real toggle so the row doesn't shift. */
.agent-availability-toggle.loading,
.agent-availability-toggle.loading:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  opacity: 1;
  cursor: default;
}

.agent-availability-toggle svg:first-child {
  font-size: 16px;
}

/* ----- Team availability chip + modal ----------------------------- */

/* Wrapper that holds both the self-toggle and the team chip on the
   right side of the availability row. */
.agent-availability-controls {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Single spinner shown while the initial agent_status + roster fetches
   are still in flight, so the row doesn't pop in piece by piece. */
.agent-availability-loading {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  height: 26px;
  color: #5616ea;
  font-size: 16px;
}

/* Tiny chip showing "X / Y" online for the bot's full agent roster.
   Click opens the team availability modal. */
.agent-team-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.agent-team-chip svg {
  font-size: 13px;
}

.agent-team-chip.has-online {
  background-color: #ecfdf5;
  border-color: #a7f3d0;
  color: #059669;
}

.agent-team-chip.all-offline {
  background-color: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.agent-team-chip:hover {
  filter: brightness(0.97);
}

/* Neutral placeholder for the team chip while roster fetch is in
   flight. Matches loading toggle so both align in size. */
.agent-team-chip.loading,
.agent-team-chip.loading:disabled {
  background-color: #f3f4f6;
  border-color: #e5e7eb;
  color: #9ca3af;
  cursor: default;
  opacity: 1;
}

.agent-team-chip.loading:hover {
  filter: none;
}

/* Modal */
.agent-team-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
  padding: 16px;
}

.agent-team-modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 640px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.agent-team-modal-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.agent-team-modal-header .live-inbox-availability-title-block {
  flex: 1 1;
  min-width: 0;
}

.agent-team-modal-body {
  padding: 14px 20px 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.agent-team-modal-title-block {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.agent-team-modal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.agent-team-modal-subtitle {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-team-modal-count {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 8px;
  white-space: nowrap;
}

.agent-team-modal-close {
  align-self: flex-start;
  background: none;
  border: none;
  font-size: 20px;
  color: #888;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  line-height: 1;
}

.agent-team-modal-close:hover {
  background: #f0f0f0;
  color: #333;
}

.agent-team-modal-list {
  list-style: none;
  margin: 0;
  padding: 4px 20px 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Section divider inside the modal list ("My availability" / "Other
   agents") matching the live inbox availability sections. */
.agent-team-modal-section-header {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 10px 0 4px;
}

.agent-team-modal-section-header:first-child {
  padding-top: 4px;
}

/* Hairline between the "My availability" and "Other agents"
   sections — matches the live inbox divider. */
.agent-team-modal-divider {
  list-style: none;
  height: 1px;
  background: #e5e7eb;
  margin: 8px 0 0;
}

/* Empty state for the "Other agents" section — matches Live Inbox
   styling so the modal feels like a sibling view. */
.agent-team-modal-empty-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
}

.agent-team-modal-empty {
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
}

.agent-team-modal-invite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 20px;
  border: 1px solid transparent;
  background-color: #ede9fe;
  color: #5616ea;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 110px;
  white-space: nowrap;
  flex-shrink: 0;
}

.agent-team-modal-invite-btn:hover {
  background-color: #ddd6fe;
}

.agent-team-modal-invite-btn svg {
  font-size: 18px;
  /* faUserPlus has a wider glyph than other icons at the same
     font-size; cap the rendered width so the pill matches sibling
     buttons. */
  width: 16px;
}

.agent-team-modal-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-radius: 8px;
}

.agent-team-modal-dot {
  font-size: 10px;
  flex-shrink: 0;
}

.agent-team-modal-dot.online {
  color: #10b981;
}

.agent-team-modal-dot.offline {
  color: #d1d5db;
}

.agent-team-modal-name {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-team-modal-you {
  color: #6b7280;
  font-weight: 400;
}

.agent-team-modal-state {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.agent-team-modal-state.online {
  color: #047857;
}

.agent-team-modal-state.offline {
  color: #9ca3af;
}

/* Per-row toggle button inside the team availability modal — same
   visual language as the bot card's Online/Offline pill so admins
   can manage teammate availability without leaving the bots page. */
.agent-team-modal-toggle-wrap {
  display: inline-flex;
}

.agent-team-modal-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  min-width: 96px;
}

.agent-team-modal-toggle.online {
  background-color: #ede9fe;
  color: #5616ea;
}

.agent-team-modal-toggle.online:hover:not(:disabled) {
  background-color: #ddd6fe;
}

.agent-team-modal-toggle.offline {
  background-color: #fef2f2;
  color: #dc2626;
}

.agent-team-modal-toggle.offline:hover:not(:disabled) {
  background-color: #fee2e2;
}

.agent-team-modal-toggle.is-disabled,
.agent-team-modal-toggle:disabled {
  cursor: not-allowed;
}

.agent-team-modal-toggle.is-disabled.online {
  background-color: transparent;
  border-color: #ddd6fe;
  color: #8b5cf6;
}

.agent-team-modal-toggle.is-disabled.offline {
  background-color: transparent;
  border-color: #fecaca;
  color: #f87171;
}

.agent-team-modal-toggle svg:first-child {
  font-size: 16px;
}

.activity-chart {
  width: 140px;
  height: 40px;
}

.activity-tooltip {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 6px 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
}

.activity-tooltip-date {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
}

.activity-tooltip-value {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.delete-btn {
  padding: 0px;
  font-size: 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  text-align: center;
  background-color: transparent;
  border: none;
  color: #6b6b6b;
  will-change: transform;
  backface-visibility: hidden;
}

.delete-btn:hover {
  transform: scale(1.1);
}

.delete-btn:disabled {
  cursor: not-allowed;
  transform: scale(1.0);
}

.bot-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 320px));
  gap: 20px;
}

.bots-overview-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}

.bots-overview-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.bots-overview-header-first-bot {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 0px;
}

.add-bot-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  background-color: #5616ea;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.add-bot-btn:hover {
  background-color: #4a14d6;
  transform: scale(1.05);
}

.bots-overview h2 {
  margin: 0;
}

.bot-card {
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  box-shadow: none;
  overflow: visible;
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  position: relative;
}

.bot-card.is-selectable {
  cursor: pointer;
}

.bot-card.is-selectable:hover {
  transform: translateY(-2px);
}

/* While its three-dot menu is open, lift the card above the cards below so
   the dropdown isn't clipped by them. The hover \`transform\` makes the card a
   stacking context that would otherwise trap the menu beneath later siblings. */
.bot-card.menu-open {
  z-index: 20;
}

/* ── Preview area ───────────────────────────────────────────────── */
.bot-card-preview {
  background: linear-gradient(135deg, #2d1a8c 0%, #5616ea 55%, #7b3cf7 100%);
  height: 136px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
}

/* When a screenshot is shown, lay the brand gradient over it as a
   translucent tint and separate it from the info area below. */
.bot-card-preview.has-shot {
  border-bottom: 1px solid #e5e7eb;
}

/* Website screenshot fills the preview, blurred to act as a backdrop for
   the widget mockup overlaid on top of it. */
.bot-card-preview-shot {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  filter: blur(0px) brightness(0.65);
  /* Scaled up so the blur's translucent edges fall outside the
     overflow-hidden preview instead of revealing the gradient behind. */
  transform: scale(1);
  z-index: 0;
}

.bot-card-preview-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.bot-card-preview-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

/* Chat widget mockup inside the preview. Always centered horizontally and
   anchored to the bottom of the preview — over the gradient when there's no
   screenshot, or over the blurred screenshot when there is one — like a chat
   window rising from the foot of the card. Top corners rounded; the bottom is
   flush with the preview edge. */
.bot-card-chat-widget {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 1;
  width: 100%;
  max-width: 170px;
  padding: 12px 14px;
  background: #ffffff;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.35);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bot-card-chat-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.bot-card-chat-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5616ea, #7b3cf7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.bot-card-chat-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-card-bubble {
  height: 11px;
  border-radius: 10px;
}

.bot-card-bubble--bot {
  width: 72%;
  background: #f3f4f6;
  align-self: flex-start;
}

.bot-card-bubble--user {
  width: 48%;
  background: linear-gradient(90deg, #5616ea, #7b3cf7);
  align-self: flex-end;
  margin-left: auto;
}

/* Plan status badges */
.bot-card-plan-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
  letter-spacing: 0.02em;
}

.bot-card-plan-badge.past-due {
  background: #fef2f2;
  color: #dc2626;
}

.bot-card-plan-badge.limit {
  background: #fff7ed;
  color: #c2410c;
}

/* ── Info area ──────────────────────────────────────────────────── */
.bot-card-info {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1;
}

.bot-card-name-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.bot-card-name-block {
  min-width: 0;
  flex: 1 1;
}

.bot-card-name {
  margin: 0 0 3px;
  font-size: 19px;
  font-weight: 600;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Inline rename input — matches the name size, brand-purple focus ring. */
.bot-card-name-input {
  margin: 0 0 3px;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 19px;
  font-weight: 600;
  color: #111827;
  padding: 2px 6px;
  border: 1px solid #5616ea;
  border-radius: 6px;
  outline: none;
  background: #fff;
}

.bot-card-name-input:disabled {
  opacity: 0.6;
}

.bot-card-trained {
  margin: 0;
  font-size: 13px;
  color: #9ca3af;
}

/* Three-dot menu */
.bot-card-menu-wrap {
  position: relative;
  flex-shrink: 0;
}

.bot-card-menu-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: 1px solid #e5e7eb;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.bot-card-menu-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

/* While the agent is still building, its options are not actionable yet — the
   three-dots button is disabled (greyed, non-clickable, no hover feedback). */
.bot-card-menu-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.bot-card-menu-btn:disabled:hover {
  background: #f3f4f6;
  border-color: #e5e7eb;
}

/* Three dots drawn as SVG circles so they stay true circles at this small
   size (a tiny border-radius box pixel-snaps to a non-round shape). Colour
   follows the button's \`currentColor\`. The viewBox carries 1px padding on
   every side so the circles never touch (and get clipped by) the SVG edge.
   Dot size + spacing live in the SVG geometry (bots.js): r=2.5 dots, 4px
   gap between them. */
.bot-card-menu-dots {
  display: block;
  fill: currentColor;
}

.bot-card-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  z-index: 1000;
  min-width: 160px;
  overflow: hidden;
  padding: 4px 0;
}

.bot-card-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-family: "DM Sans", sans-serif;
  text-align: left;
  transition: background 0.12s ease;
  color: #374151;
}

.bot-card-menu-item:hover {
  background: #f9fafb;
}

.bot-card-menu-item.danger {
  color: #dc2626;
}

.bot-card-menu-item.danger:hover {
  background: #fef2f2;
}

/* ── Stats row ──────────────────────────────────────────────────── */
.bot-card-stats {
  display: flex;
  align-items: stretch;
  border-top: 1px solid #f3f4f6;
  padding-top: 18px;
  margin-top: 6px;
  gap: 0;
}

.bot-card-stat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.bot-card-stat-sep {
  width: 1px;
  background: #f3f4f6;
  flex-shrink: 0;
  margin: 0 4px;
}

.bot-card-stat-value {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
}

.bot-card-stat-value.is-online {
  color: #16a34a;
}

.bot-card-stat-label {
  font-size: 11px;
  color: #9ca3af;
  text-align: center;
  white-space: nowrap;
}

/* Activity chart stat cell */
.bot-card-stat--chart {
  flex: 1.4 1;
  justify-content: flex-start;
}

.bot-card-stat--chart .bot-card-stat-label {
  margin-top: auto;
}

.bot-card-chart-area {
  width: 100%;
  height: 36px;
  margin-bottom: 4px;
}

/* Live agents stat — pointer cursor, subtle hover */
.bot-card-stat--clickable {
  cursor: pointer;
  border-radius: 8px;
  padding: 2px 4px;
  transition: background 0.15s ease;
}

.bot-card-stat--clickable:hover {
  background: #f3f4f6;
}

/* Configure button at card bottom */
.bot-card-configure-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background: #f4f1fd;
  color: #5616ea;
  font-size: 14px;
  font-weight: 600;
  font-family: "DM Sans", sans-serif;
  cursor: pointer;
  transition: background 0.2s ease;
}

.bot-card-configure-btn:hover {
  background: #ece5fb;
}

.bot-card.building {
  position: relative;
  background-color: #e1e5eb;
  border: none;
  overflow: hidden;
  /* The padding gap IS the rotating border: the opaque content (z-1) sits
     inside it, so the gradient (z-0) shows as a frame around the whole card
     instead of being painted over by the preview at the top. */
  padding: 5px;
}

.bot-card.building::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200%;
  height: 200%;
  /* Comet / "snake": a bright head (full colour) that fades down its tail
     into a transparent gap (no colour). The transparent arc shows the card's
     grey background through the border. Now that the content is inset, this
     is visible all the way around the card. */
  background: conic-gradient(
    transparent 0deg,
    transparent 160deg,
    rgba(94, 27, 255, 0.2) 190deg,
    rgba(94, 27, 255, 0.5) 210deg,
    #5616ea 230deg,
    #9966ff 295deg,
    #5616ea 360deg
  );
  transform: translate(-50%, -50%);
  animation: rotateBorder 3s linear infinite;
  z-index: 0;
}

.bot-card.building > * {
  position: relative;
  z-index: 1;
}

/* Round the inner content so it nests inside the rotating frame, and keep the
   info area opaque so the gradient never shows through behind the text. */
.bot-card.building .bot-card-preview {
  border-radius: 6px 6px 0 0;
}

.bot-card.building .bot-card-info {
  background-color: #e1e5eb;
  border-radius: 0 0 6px 6px;
}

@keyframes rotateBorder {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.progress-spinner {
  position: relative;
  width: 40px;
  height: 40px;
}

.circular-progress {
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
}

/* The building preview sits on the purple gradient, so the spinner + label
   are light. (Purple-on-purple was invisible before.) */
.circle-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.3);
  stroke-width: 3;
}

.circle {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-dasharray: 100;
  transition: stroke-dashoffset 0.3s ease-in-out;
}

.percentage-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 11px;
  font-weight: bold;
  color: #ffffff;
}

.progress-parent {
  display: flex;
  align-items: center;
  height: 18px;
  width: 100%;
}

.progress-container {
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  height: 12px;
  position: relative;
  align-items: center;
}

.progress-bar {
  height: 100%;
  background-color: #5616ea;
  transition: width 0.3s ease;
}

.disabled-link {
  pointer-events: none;
  color: gray;
}

.bot-card p {
  margin: 0;
}

.bot-card h2 {
  color: #656565;
  font-size: 1.7rem;
}

.bot-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.bot-btn {
  flex: 1 1;
  padding: 10px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  color: rgb(58, 58, 58);
  will-change: transform;
  backface-visibility: hidden;
}

.bot-btn:hover {
  background-color: #ededed;
  transform: scale(1.05);
}

.bot-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: scale(1.0);
  background-color: #f9f9f9;
}

.button-content {
  display: flex;
  gap: 8px;
  align-items: center;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 200px;
}

.spinner {
  margin-top: 100px;
  border: 8px solid #f3f3f3;
  border-top: 8px solid #5616ea;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1.1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.message-count-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.limit-reached {
  background-color: red;
  padding: 5px;
  padding-top: 4.5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 12px;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.bot-name-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.edit-icon {
  margin-left: 6px;
  margin-bottom: 2px;
  font-size: 0.95em;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  color: #5616ea;
}

.bot-name-wrapper:hover .edit-icon,
.bot-name-wrapper:focus-within .edit-icon {
  opacity: 1;
  pointer-events: auto;
  cursor: pointer;
}

.bot-name-input {
  font-size: 1.7rem;
  border: 1px solid transparent;
  padding: 0;
  width: 85%;
  border-radius: 8px;
  color: #656565;
  font-weight: 600;
}

.bot-name-input:focus {
  outline: none;
  border-color: #c9c9c9;
}

.usage-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-bottom: 2px;
}

.usage-indicator.green {
  background-color: green;
}

.usage-indicator.yellow {
  background-color: orange;
}

.usage-indicator.orange {
  background-color: orange;
}

.usage-indicator.red {
  background-color: red;
}

.billing-action-button {
  width: 100%;
  margin-top: 10px;
  border: none;
  background-color: #5616ea;
  font-size: 16px;
  text-align: center;
  padding: 8px;
  border-radius: 8px;
  color: white;
  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  cursor: pointer;
  will-change: transform;
  backface-visibility: hidden;
}

.billing-action-button:hover {
  background-color: #4a14d6;
  transform: translateY(-1px);
}

.billing-action-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  background-color: rgb(78, 78, 78);
}

.billing-action-button-content {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.success-score-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}

@media (max-width: 768px) {
  /* One full-width column: the desktop grid caps each track at 320px, which on
     a phone leaves empty space to the right of the card. 1fr makes the card
     span the full container width. */
  .bot-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .bot-card {
    width: 100%;
  }

  .bot-card h2 {
    font-size: 1.7rem;
  }

  .bots-overview {
    margin-top: 5px;
  }

  .bots-overview-header {
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .bots-overview-header-first-bot {
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .bots-overview h1 {
    font-size: 34px;
    margin: 0;
    padding: 0;
  }

  .bot-btn {
    font-size: 15px;
  }

  .add-bot-btn {
    font-size: 17px;
  }
}


/* Past-due payment notice on a bot card. Shown when the bot's Stripe
   subscription is in status \`past_due\`. Placed at the TOP of the
   bot card so it's unmissable. The button opens the Stripe customer
   portal directly on the "update payment method" screen so Stripe
   can retry the open invoice automatically. */
.payment-overdue-banner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    margin-bottom: 12px;
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 10px;
    color: #991b1b;
}

.payment-overdue-icon {
    color: #dc2626;
    font-size: 18px;
    flex-shrink: 0;
    margin-top: 2px;
}

.payment-overdue-body {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.payment-overdue-title {
    font-size: 14px;
    font-weight: 700;
}

.payment-overdue-text {
    font-size: 13px;
    line-height: 1.4;
}

.payment-overdue-button {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    margin-top: 2px;
    border: none;
    border-radius: 8px;
    background-color: #dc2626;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.payment-overdue-button:hover:not(:disabled) {
    background-color: #b91c1c;
}

.payment-overdue-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/bots.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,6GAA6G;EAC7G,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;;yDAEyD;AACzD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0EAA0E;EAC1E,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;yEACyE;AACzE;;EAEE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,uEAAuE;;AAEvE;wCACwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;mEACmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;6CAC6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;0DAC0D;AAC1D;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;4DAC4D;AAC5D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;+CAC+C;AAC/C;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;oDACoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf;;eAEa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;oEAEoE;AACpE;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+EAA+E;EAC/E,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iFAAiF;EACjF,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;gFAEgF;AAChF;EACE,WAAW;AACb;;AAEA,sEAAsE;AACtE;EACE,0EAA0E;EAC1E,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;+DAC+D;AAC/D;EACE,gCAAgC;AAClC;;AAEA;6CAC6C;AAC7C;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;EAClC;wEACsE;EACtE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;;iCAIiC;AACjC;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oDAAoD;EACpD,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;8EAC8E;AAC9E;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;sBAKsB;AACtB;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,MAAM;AACR;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB;;+DAE6D;EAC7D,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ;;;8CAG4C;EAC5C;;;;;;;;GAQC;EACD,gCAAgC;EAChC,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;0EAC0E;AAC1E;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;wDACwD;AACxD;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qIAAqI;EACrI,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,4FAA4F;EAC5F,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;;qCAEmC;EACnC;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;;;8CAI8C;AAC9C;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".bots-overview {\r\n  font-family: \"DM Sans\", sans-serif;\r\n  max-width: var(--max-width-10xl, 120rem);\r\n  margin: 0 auto;\r\n  padding: 22px 24px 48px;\r\n}\r\n\r\n.bots-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.45;\r\n  max-width: 800px;\r\n}\r\n\r\n.bots-info-box p {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.bots-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n}\r\n\r\n.name-button-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid rgb(231, 231, 231);\r\n}\r\n\r\n.name-status-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.bot-status-icon {\r\n  color: #5616ea;\r\n  font-size: 25px;\r\n}\r\n\r\n.bot-status-icon-failed {\r\n  color: rgb(214, 8, 8);\r\n  font-size: 25px;\r\n}\r\n\r\n.url-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.plan-info-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.plan-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.plan-info-action-button {\r\n  border: none;\r\n  background-color: #5616ea;\r\n  font-size: 13px;\r\n  text-align: center;\r\n  padding: 4px;\r\n  padding-right: 6px;\r\n  padding-left: 6px;\r\n  border-radius: 8px;\r\n  color: white;\r\n  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  cursor: pointer;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.plan-info-action-button:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.plan-info-action-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: scale(1.0);\r\n  background-color: rgb(78, 78, 78);\r\n}\r\n\r\n/* Red variant of the plan-info action button, shown when the bot's\r\n   subscription is past_due. Clicking it opens the Stripe customer\r\n   portal directly on the \"update payment method\" flow. */\r\n.plan-info-action-button-update-payment {\r\n  background-color: #dc2626;\r\n}\r\n\r\n.plan-info-action-button-update-payment:hover {\r\n  background-color: #b91c1c;\r\n}\r\n\r\n.plan-info-action-button-content {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n  font-size: 14px;\r\n}\r\n\r\n.star-icon-tooltip-wrapper {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  cursor: default;\r\n  transform: translateY(1.5px);\r\n}\r\n\r\n.star-icon-tooltip {\r\n  position: absolute;\r\n  bottom: calc(100% + 8px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding: 5px 10px;\r\n  border-radius: 6px;\r\n  white-space: nowrap;\r\n  pointer-events: none;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n  box-shadow: 0 4px 12px rgba(86, 22, 234, 0.3);\r\n}\r\n\r\n.star-icon-tooltip::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border: 5px solid transparent;\r\n  border-top-color: #5616ea;\r\n}\r\n\r\n.star-icon-tooltip-wrapper:hover .star-icon-tooltip {\r\n  opacity: 1;\r\n}\r\n\r\n.star-icon-pro-subscription {\r\n  color: #5616ea;\r\n}\r\n\r\n.star-icon-trialing {\r\n  color: #3b82f6;\r\n}\r\n\r\n.star-icon-expires {\r\n  color: #f59e0b;\r\n}\r\n\r\n.star-icon-cancelled {\r\n  color: #ef4444;\r\n}\r\n\r\n.star-icon-past-due {\r\n  color: #ef4444;\r\n}\r\n\r\n.messages-used-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.created-at-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.activity-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: -2px;\r\n}\r\n\r\n/* Agent availability row (Online/Offline toggle) */\r\n.agent-availability-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: 6px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.agent-availability-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  border: none;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;\r\n  min-width: 96px;\r\n}\r\n\r\n.agent-availability-toggle.online {\r\n  background-color: #ede9fe;\r\n  color: #5616ea;\r\n}\r\n\r\n.agent-availability-toggle.online:hover:not(:disabled) {\r\n  background-color: #ddd6fe;\r\n}\r\n\r\n.agent-availability-toggle.offline {\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n}\r\n\r\n.agent-availability-toggle.offline:hover:not(:disabled) {\r\n  background-color: #fee2e2;\r\n}\r\n\r\n.agent-availability-toggle:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n  background-color: #f3f4f6;\r\n  color: #9ca3af;\r\n}\r\n\r\n/* Neutral placeholder shown while initial agent_status fetch is in\r\n   flight. Same shape/size as the real toggle so the row doesn't shift. */\r\n.agent-availability-toggle.loading,\r\n.agent-availability-toggle.loading:disabled {\r\n  background-color: #f3f4f6;\r\n  color: #9ca3af;\r\n  opacity: 1;\r\n  cursor: default;\r\n}\r\n\r\n.agent-availability-toggle svg:first-child {\r\n  font-size: 16px;\r\n}\r\n\r\n/* ----- Team availability chip + modal ----------------------------- */\r\n\r\n/* Wrapper that holds both the self-toggle and the team chip on the\r\n   right side of the availability row. */\r\n.agent-availability-controls {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n/* Single spinner shown while the initial agent_status + roster fetches\r\n   are still in flight, so the row doesn't pop in piece by piece. */\r\n.agent-availability-loading {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  height: 26px;\r\n  color: #5616ea;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Tiny chip showing \"X / Y\" online for the bot's full agent roster.\r\n   Click opens the team availability modal. */\r\n.agent-team-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 4px 10px;\r\n  border-radius: 20px;\r\n  border: 1px solid #e5e7eb;\r\n  background-color: #f9fafb;\r\n  color: #4b5563;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.agent-team-chip svg {\r\n  font-size: 13px;\r\n}\r\n\r\n.agent-team-chip.has-online {\r\n  background-color: #ecfdf5;\r\n  border-color: #a7f3d0;\r\n  color: #059669;\r\n}\r\n\r\n.agent-team-chip.all-offline {\r\n  background-color: #fef2f2;\r\n  border-color: #fecaca;\r\n  color: #dc2626;\r\n}\r\n\r\n.agent-team-chip:hover {\r\n  filter: brightness(0.97);\r\n}\r\n\r\n/* Neutral placeholder for the team chip while roster fetch is in\r\n   flight. Matches loading toggle so both align in size. */\r\n.agent-team-chip.loading,\r\n.agent-team-chip.loading:disabled {\r\n  background-color: #f3f4f6;\r\n  border-color: #e5e7eb;\r\n  color: #9ca3af;\r\n  cursor: default;\r\n  opacity: 1;\r\n}\r\n\r\n.agent-team-chip.loading:hover {\r\n  filter: none;\r\n}\r\n\r\n/* Modal */\r\n.agent-team-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(17, 24, 39, 0.45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1300;\r\n  padding: 16px;\r\n}\r\n\r\n.agent-team-modal {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);\r\n  width: 100%;\r\n  max-width: 640px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.agent-team-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.agent-team-modal-header .live-inbox-availability-title-block {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.agent-team-modal-body {\r\n  padding: 14px 20px 16px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.agent-team-modal-title-block {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.agent-team-modal-title {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.agent-team-modal-subtitle {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.agent-team-modal-count {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  background: #f3f4f6;\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.agent-team-modal-close {\r\n  align-self: flex-start;\r\n  background: none;\r\n  border: none;\r\n  font-size: 20px;\r\n  color: #888;\r\n  cursor: pointer;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n  line-height: 1;\r\n}\r\n\r\n.agent-team-modal-close:hover {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.agent-team-modal-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 4px 20px 16px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n/* Section divider inside the modal list (\"My availability\" / \"Other\r\n   agents\") matching the live inbox availability sections. */\r\n.agent-team-modal-section-header {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  padding: 10px 0 4px;\r\n}\r\n\r\n.agent-team-modal-section-header:first-child {\r\n  padding-top: 4px;\r\n}\r\n\r\n/* Hairline between the \"My availability\" and \"Other agents\"\r\n   sections — matches the live inbox divider. */\r\n.agent-team-modal-divider {\r\n  list-style: none;\r\n  height: 1px;\r\n  background: #e5e7eb;\r\n  margin: 8px 0 0;\r\n}\r\n\r\n/* Empty state for the \"Other agents\" section — matches Live Inbox\r\n   styling so the modal feels like a sibling view. */\r\n.agent-team-modal-empty-block {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 4px 0;\r\n}\r\n\r\n.agent-team-modal-empty {\r\n  font-size: 13px;\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n}\r\n\r\n.agent-team-modal-invite-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 4px 14px;\r\n  border-radius: 20px;\r\n  border: 1px solid transparent;\r\n  background-color: #ede9fe;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  min-width: 110px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.agent-team-modal-invite-btn:hover {\r\n  background-color: #ddd6fe;\r\n}\r\n\r\n.agent-team-modal-invite-btn svg {\r\n  font-size: 18px;\r\n  /* faUserPlus has a wider glyph than other icons at the same\r\n     font-size; cap the rendered width so the pill matches sibling\r\n     buttons. */\r\n  width: 16px;\r\n}\r\n\r\n.agent-team-modal-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 8px 0;\r\n  border-radius: 8px;\r\n}\r\n\r\n.agent-team-modal-dot {\r\n  font-size: 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.agent-team-modal-dot.online {\r\n  color: #10b981;\r\n}\r\n\r\n.agent-team-modal-dot.offline {\r\n  color: #d1d5db;\r\n}\r\n\r\n.agent-team-modal-name {\r\n  flex: 1;\r\n  min-width: 0;\r\n  font-size: 14px;\r\n  color: #111827;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.agent-team-modal-you {\r\n  color: #6b7280;\r\n  font-weight: 400;\r\n}\r\n\r\n.agent-team-modal-state {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.agent-team-modal-state.online {\r\n  color: #047857;\r\n}\r\n\r\n.agent-team-modal-state.offline {\r\n  color: #9ca3af;\r\n}\r\n\r\n/* Per-row toggle button inside the team availability modal — same\r\n   visual language as the bot card's Online/Offline pill so admins\r\n   can manage teammate availability without leaving the bots page. */\r\n.agent-team-modal-toggle-wrap {\r\n  display: inline-flex;\r\n}\r\n\r\n.agent-team-modal-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 4px 12px;\r\n  border-radius: 20px;\r\n  border: 1px solid transparent;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\r\n  min-width: 96px;\r\n}\r\n\r\n.agent-team-modal-toggle.online {\r\n  background-color: #ede9fe;\r\n  color: #5616ea;\r\n}\r\n\r\n.agent-team-modal-toggle.online:hover:not(:disabled) {\r\n  background-color: #ddd6fe;\r\n}\r\n\r\n.agent-team-modal-toggle.offline {\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n}\r\n\r\n.agent-team-modal-toggle.offline:hover:not(:disabled) {\r\n  background-color: #fee2e2;\r\n}\r\n\r\n.agent-team-modal-toggle.is-disabled,\r\n.agent-team-modal-toggle:disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.agent-team-modal-toggle.is-disabled.online {\r\n  background-color: transparent;\r\n  border-color: #ddd6fe;\r\n  color: #8b5cf6;\r\n}\r\n\r\n.agent-team-modal-toggle.is-disabled.offline {\r\n  background-color: transparent;\r\n  border-color: #fecaca;\r\n  color: #f87171;\r\n}\r\n\r\n.agent-team-modal-toggle svg:first-child {\r\n  font-size: 16px;\r\n}\r\n\r\n.activity-chart {\r\n  width: 140px;\r\n  height: 40px;\r\n}\r\n\r\n.activity-tooltip {\r\n  background: #fff;\r\n  border: 1px solid #e6e6e6;\r\n  border-radius: 8px;\r\n  padding: 6px 8px;\r\n  box-shadow: 0 4px 10px rgba(0,0,0,0.08);\r\n}\r\n\r\n.activity-tooltip-date {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.activity-tooltip-value {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.delete-btn {\r\n  padding: 0px;\r\n  font-size: 20px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  text-align: center;\r\n  background-color: transparent;\r\n  border: none;\r\n  color: #6b6b6b;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.delete-btn:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.delete-btn:disabled {\r\n  cursor: not-allowed;\r\n  transform: scale(1.0);\r\n}\r\n\r\n.bot-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(280px, 320px));\r\n  gap: 20px;\r\n}\r\n\r\n.bots-overview-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.bots-overview-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.bots-overview-header-first-bot {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.add-bot-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  border: none;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  padding: 8px 16px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: background-color 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.add-bot-btn:hover {\r\n  background-color: #4a14d6;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.bots-overview h2 {\r\n  margin: 0;\r\n}\r\n\r\n.bot-card {\r\n  border-radius: 10px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #ffffff;\r\n  box-shadow: none;\r\n  overflow: visible;\r\n  transition: transform 0.2s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n}\r\n\r\n.bot-card.is-selectable {\r\n  cursor: pointer;\r\n}\r\n\r\n.bot-card.is-selectable:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* While its three-dot menu is open, lift the card above the cards below so\r\n   the dropdown isn't clipped by them. The hover `transform` makes the card a\r\n   stacking context that would otherwise trap the menu beneath later siblings. */\r\n.bot-card.menu-open {\r\n  z-index: 20;\r\n}\r\n\r\n/* ── Preview area ───────────────────────────────────────────────── */\r\n.bot-card-preview {\r\n  background: linear-gradient(135deg, #2d1a8c 0%, #5616ea 55%, #7b3cf7 100%);\r\n  height: 136px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  position: relative;\r\n  flex-shrink: 0;\r\n  overflow: hidden;\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n/* When a screenshot is shown, lay the brand gradient over it as a\r\n   translucent tint and separate it from the info area below. */\r\n.bot-card-preview.has-shot {\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n/* Website screenshot fills the preview, blurred to act as a backdrop for\r\n   the widget mockup overlaid on top of it. */\r\n.bot-card-preview-shot {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: top center;\r\n  filter: blur(0px) brightness(0.65);\r\n  /* Scaled up so the blur's translucent edges fall outside the\r\n     overflow-hidden preview instead of revealing the gradient behind. */\r\n  transform: scale(1);\r\n  z-index: 0;\r\n}\r\n\r\n.bot-card-preview-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.bot-card-preview-label {\r\n  font-size: 13px;\r\n  color: rgba(255, 255, 255, 0.8);\r\n  font-weight: 500;\r\n}\r\n\r\n/* Chat widget mockup inside the preview. Always centered horizontally and\r\n   anchored to the bottom of the preview — over the gradient when there's no\r\n   screenshot, or over the blurred screenshot when there is one — like a chat\r\n   window rising from the foot of the card. Top corners rounded; the bottom is\r\n   flush with the preview edge. */\r\n.bot-card-chat-widget {\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: 0;\r\n  transform: translateX(-50%);\r\n  z-index: 1;\r\n  width: 100%;\r\n  max-width: 170px;\r\n  padding: 12px 14px;\r\n  background: #ffffff;\r\n  border-radius: 12px 12px 0 0;\r\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.35);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.bot-card-chat-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.bot-card-chat-avatar {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #5616ea, #7b3cf7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.bot-card-chat-name {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-card-bubble {\r\n  height: 11px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.bot-card-bubble--bot {\r\n  width: 72%;\r\n  background: #f3f4f6;\r\n  align-self: flex-start;\r\n}\r\n\r\n.bot-card-bubble--user {\r\n  width: 48%;\r\n  background: linear-gradient(90deg, #5616ea, #7b3cf7);\r\n  align-self: flex-end;\r\n  margin-left: auto;\r\n}\r\n\r\n/* Plan status badges */\r\n.bot-card-plan-badge {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 2;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  padding: 3px 8px;\r\n  border-radius: 20px;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.bot-card-plan-badge.past-due {\r\n  background: #fef2f2;\r\n  color: #dc2626;\r\n}\r\n\r\n.bot-card-plan-badge.limit {\r\n  background: #fff7ed;\r\n  color: #c2410c;\r\n}\r\n\r\n/* ── Info area ──────────────────────────────────────────────────── */\r\n.bot-card-info {\r\n  padding: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  flex: 1;\r\n}\r\n\r\n.bot-card-name-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.bot-card-name-block {\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.bot-card-name {\r\n  margin: 0 0 3px;\r\n  font-size: 19px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Inline rename input — matches the name size, brand-purple focus ring. */\r\n.bot-card-name-input {\r\n  margin: 0 0 3px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  font-family: inherit;\r\n  font-size: 19px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  padding: 2px 6px;\r\n  border: 1px solid #5616ea;\r\n  border-radius: 6px;\r\n  outline: none;\r\n  background: #fff;\r\n}\r\n\r\n.bot-card-name-input:disabled {\r\n  opacity: 0.6;\r\n}\r\n\r\n.bot-card-trained {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #9ca3af;\r\n}\r\n\r\n/* Three-dot menu */\r\n.bot-card-menu-wrap {\r\n  position: relative;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.bot-card-menu-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  border-radius: 9px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #f3f4f6;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.bot-card-menu-btn:hover {\r\n  background: #e5e7eb;\r\n  border-color: #d1d5db;\r\n}\r\n\r\n/* While the agent is still building, its options are not actionable yet — the\r\n   three-dots button is disabled (greyed, non-clickable, no hover feedback). */\r\n.bot-card-menu-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.45;\r\n}\r\n.bot-card-menu-btn:disabled:hover {\r\n  background: #f3f4f6;\r\n  border-color: #e5e7eb;\r\n}\r\n\r\n/* Three dots drawn as SVG circles so they stay true circles at this small\r\n   size (a tiny border-radius box pixel-snaps to a non-round shape). Colour\r\n   follows the button's `currentColor`. The viewBox carries 1px padding on\r\n   every side so the circles never touch (and get clipped by) the SVG edge.\r\n   Dot size + spacing live in the SVG geometry (bots.js): r=2.5 dots, 4px\r\n   gap between them. */\r\n.bot-card-menu-dots {\r\n  display: block;\r\n  fill: currentColor;\r\n}\r\n\r\n.bot-card-menu {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  right: 0;\r\n  background: #ffffff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);\r\n  z-index: 1000;\r\n  min-width: 160px;\r\n  overflow: hidden;\r\n  padding: 4px 0;\r\n}\r\n\r\n.bot-card-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 9px 14px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  text-align: left;\r\n  transition: background 0.12s ease;\r\n  color: #374151;\r\n}\r\n\r\n.bot-card-menu-item:hover {\r\n  background: #f9fafb;\r\n}\r\n\r\n.bot-card-menu-item.danger {\r\n  color: #dc2626;\r\n}\r\n\r\n.bot-card-menu-item.danger:hover {\r\n  background: #fef2f2;\r\n}\r\n\r\n/* ── Stats row ──────────────────────────────────────────────────── */\r\n.bot-card-stats {\r\n  display: flex;\r\n  align-items: stretch;\r\n  border-top: 1px solid #f3f4f6;\r\n  padding-top: 18px;\r\n  margin-top: 6px;\r\n  gap: 0;\r\n}\r\n\r\n.bot-card-stat {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  min-width: 0;\r\n}\r\n\r\n.bot-card-stat-sep {\r\n  width: 1px;\r\n  background: #f3f4f6;\r\n  flex-shrink: 0;\r\n  margin: 0 4px;\r\n}\r\n\r\n.bot-card-stat-value {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #111827;\r\n  white-space: nowrap;\r\n}\r\n\r\n.bot-card-stat-value.is-online {\r\n  color: #16a34a;\r\n}\r\n\r\n.bot-card-stat-label {\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Activity chart stat cell */\r\n.bot-card-stat--chart {\r\n  flex: 1.4;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.bot-card-stat--chart .bot-card-stat-label {\r\n  margin-top: auto;\r\n}\r\n\r\n.bot-card-chart-area {\r\n  width: 100%;\r\n  height: 36px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* Live agents stat — pointer cursor, subtle hover */\r\n.bot-card-stat--clickable {\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  padding: 2px 4px;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.bot-card-stat--clickable:hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n/* Configure button at card bottom */\r\n.bot-card-configure-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 7px;\r\n  width: 100%;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  background: #f4f1fd;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.bot-card-configure-btn:hover {\r\n  background: #ece5fb;\r\n}\r\n\r\n.bot-card.building {\r\n  position: relative;\r\n  background-color: #e1e5eb;\r\n  border: none;\r\n  overflow: hidden;\r\n  /* The padding gap IS the rotating border: the opaque content (z-1) sits\r\n     inside it, so the gradient (z-0) shows as a frame around the whole card\r\n     instead of being painted over by the preview at the top. */\r\n  padding: 5px;\r\n}\r\n\r\n.bot-card.building::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 200%;\r\n  height: 200%;\r\n  /* Comet / \"snake\": a bright head (full colour) that fades down its tail\r\n     into a transparent gap (no colour). The transparent arc shows the card's\r\n     grey background through the border. Now that the content is inset, this\r\n     is visible all the way around the card. */\r\n  background: conic-gradient(\r\n    transparent 0deg,\r\n    transparent 160deg,\r\n    rgba(94, 27, 255, 0.2) 190deg,\r\n    rgba(94, 27, 255, 0.5) 210deg,\r\n    #5616ea 230deg,\r\n    #9966ff 295deg,\r\n    #5616ea 360deg\r\n  );\r\n  transform: translate(-50%, -50%);\r\n  animation: rotateBorder 3s linear infinite;\r\n  z-index: 0;\r\n}\r\n\r\n.bot-card.building > * {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n/* Round the inner content so it nests inside the rotating frame, and keep the\r\n   info area opaque so the gradient never shows through behind the text. */\r\n.bot-card.building .bot-card-preview {\r\n  border-radius: 6px 6px 0 0;\r\n}\r\n\r\n.bot-card.building .bot-card-info {\r\n  background-color: #e1e5eb;\r\n  border-radius: 0 0 6px 6px;\r\n}\r\n\r\n@keyframes rotateBorder {\r\n  from {\r\n    transform: translate(-50%, -50%) rotate(0deg);\r\n  }\r\n  to {\r\n    transform: translate(-50%, -50%) rotate(360deg);\r\n  }\r\n}\r\n\r\n.progress-spinner {\r\n  position: relative;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.circular-progress {\r\n  transform: rotate(-90deg);\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* The building preview sits on the purple gradient, so the spinner + label\r\n   are light. (Purple-on-purple was invisible before.) */\r\n.circle-bg {\r\n  fill: none;\r\n  stroke: rgba(255, 255, 255, 0.3);\r\n  stroke-width: 3;\r\n}\r\n\r\n.circle {\r\n  fill: none;\r\n  stroke: #ffffff;\r\n  stroke-width: 3;\r\n  stroke-linecap: round;\r\n  stroke-dasharray: 100;\r\n  transition: stroke-dashoffset 0.3s ease-in-out;\r\n}\r\n\r\n.percentage-text {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 11px;\r\n  font-weight: bold;\r\n  color: #ffffff;\r\n}\r\n\r\n.progress-parent {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 18px;\r\n  width: 100%;\r\n}\r\n\r\n.progress-container {\r\n  width: 100%;\r\n  background-color: #ffffff;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  height: 12px;\r\n  position: relative;\r\n  align-items: center;\r\n}\r\n\r\n.progress-bar {\r\n  height: 100%;\r\n  background-color: #5616ea;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.disabled-link {\r\n  pointer-events: none;\r\n  color: gray;\r\n}\r\n\r\n.bot-card p {\r\n  margin: 0;\r\n}\r\n\r\n.bot-card h2 {\r\n  color: #656565;\r\n  font-size: 1.7rem;\r\n}\r\n\r\n.bot-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.bot-btn {\r\n  flex: 1;\r\n  padding: 10px;\r\n  font-size: 14px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.5s ease, color 0.3s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), border-color 0.3s ease;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  color: rgb(58, 58, 58);\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.bot-btn:hover {\r\n  background-color: #ededed;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.bot-btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: scale(1.0);\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.button-content {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.loading-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  min-height: 200px;\r\n}\r\n\r\n.spinner {\r\n  margin-top: 100px;\r\n  border: 8px solid #f3f3f3;\r\n  border-top: 8px solid #5616ea;\r\n  border-radius: 50%;\r\n  width: 80px;\r\n  height: 80px;\r\n  animation: spin 1.1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.message-count-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.limit-reached {\r\n  background-color: red;\r\n  padding: 5px;\r\n  padding-top: 4.5px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n  border-radius: 12px;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.bot-name-wrapper {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.edit-icon {\r\n  margin-left: 6px;\r\n  margin-bottom: 2px;\r\n  font-size: 0.95em;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.2s;\r\n  color: #5616ea;\r\n}\r\n\r\n.bot-name-wrapper:hover .edit-icon,\r\n.bot-name-wrapper:focus-within .edit-icon {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.bot-name-input {\r\n  font-size: 1.7rem;\r\n  border: 1px solid transparent;\r\n  padding: 0;\r\n  width: 85%;\r\n  border-radius: 8px;\r\n  color: #656565;\r\n  font-weight: 600;\r\n}\r\n\r\n.bot-name-input:focus {\r\n  outline: none;\r\n  border-color: #c9c9c9;\r\n}\r\n\r\n.usage-indicator {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.usage-indicator.green {\r\n  background-color: green;\r\n}\r\n\r\n.usage-indicator.yellow {\r\n  background-color: orange;\r\n}\r\n\r\n.usage-indicator.orange {\r\n  background-color: orange;\r\n}\r\n\r\n.usage-indicator.red {\r\n  background-color: red;\r\n}\r\n\r\n.billing-action-button {\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  border: none;\r\n  background-color: #5616ea;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  color: white;\r\n  transition: background-color 0.5s ease, transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  cursor: pointer;\r\n  will-change: transform;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n.billing-action-button:hover {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.billing-action-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n  transform: none;\r\n  background-color: rgb(78, 78, 78);\r\n}\r\n\r\n.billing-action-button-content {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 16px;\r\n}\r\n\r\n.success-score-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px !important;\r\n  margin-top: 10px !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  /* One full-width column: the desktop grid caps each track at 320px, which on\r\n     a phone leaves empty space to the right of the card. 1fr makes the card\r\n     span the full container width. */\r\n  .bot-container {\r\n    grid-template-columns: 1fr;\r\n    gap: 16px;\r\n  }\r\n\r\n  .bot-card {\r\n    width: 100%;\r\n  }\r\n\r\n  .bot-card h2 {\r\n    font-size: 1.7rem;\r\n  }\r\n\r\n  .bots-overview {\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .bots-overview-header {\r\n    font-size: 12px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .bots-overview-header-first-bot {\r\n    font-size: 12px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .bots-overview h1 {\r\n    font-size: 34px;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .bot-btn {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .add-bot-btn {\r\n    font-size: 17px;\r\n  }\r\n}\r\n\r\n\r\n/* Past-due payment notice on a bot card. Shown when the bot's Stripe\r\n   subscription is in status `past_due`. Placed at the TOP of the\r\n   bot card so it's unmissable. The button opens the Stripe customer\r\n   portal directly on the \"update payment method\" screen so Stripe\r\n   can retry the open invoice automatically. */\r\n.payment-overdue-banner {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n    padding: 12px 14px;\r\n    margin-bottom: 12px;\r\n    background-color: #fef2f2;\r\n    border: 1px solid #fecaca;\r\n    border-radius: 10px;\r\n    color: #991b1b;\r\n}\r\n\r\n.payment-overdue-icon {\r\n    color: #dc2626;\r\n    font-size: 18px;\r\n    flex-shrink: 0;\r\n    margin-top: 2px;\r\n}\r\n\r\n.payment-overdue-body {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    min-width: 0;\r\n}\r\n\r\n.payment-overdue-title {\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n}\r\n\r\n.payment-overdue-text {\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.payment-overdue-button {\r\n    align-self: flex-start;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 8px 12px;\r\n    margin-top: 2px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background-color: #dc2626;\r\n    color: #fff;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.15s ease;\r\n}\r\n\r\n.payment-overdue-button:hover:not(:disabled) {\r\n    background-color: #b91c1c;\r\n}\r\n\r\n.payment-overdue-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
